import { useEffect, useRef, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import i18n from '../../common/i18n';
import HeaderTags from '../../common/HeaderTags';
import HelpHero from './components/HelpHero';
import HelpCategories from './components/HelpCategories';
import HelpFaqs from './components/HelpFaqs';
import HelpChannels from './components/HelpChannels';
import SectionHeading from './components/SectionHeading';
import { DEFAULT_HELP_CATEGORY } from './commons/helpData';
import {
  HELP_MAX_WIDTH, helpColors, helpFontScopeSx, helpTheme,
} from './style/helpStyles';

const HelpPage = () => {
  const matchesMobile = useMediaQuery('(max-width: 1201px)');
  const [selectedCategory, setSelectedCategory] = useState(DEFAULT_HELP_CATEGORY);
  const faqsRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  const handleSelectCategory = (categoryId) => {
    setSelectedCategory(categoryId);
    if (matchesMobile) {
      faqsRef.current?.scrollToGroup(categoryId);
    }
  };

  return (
    <ThemeProvider theme={helpTheme}>
      <HeaderTags title={i18n.footerHelp} content={i18n.metaDescriptionHelp} />

      <Box sx={helpFontScopeSx}>
        <HelpHero isMobile={matchesMobile} />

        {matchesMobile ? (
          <>
            <Box sx={{ backgroundColor: helpColors.bg, padding: '48px 20px 44px' }}>
              <HelpCategories
                selectedCategory={selectedCategory}
                onSelectCategory={handleSelectCategory}
                isMobile
              />
            </Box>
            <Box sx={{ backgroundColor: helpColors.bg, padding: '44px 20px 40px' }}>
              <HelpFaqs
                ref={faqsRef}
                selectedCategory={selectedCategory}
                isMobile
                showAllGroups
              />
            </Box>
          </>
        ) : (
          <Box sx={{ backgroundColor: helpColors.white, padding: '64px 24px 72px' }}>
            <Box sx={{ maxWidth: HELP_MAX_WIDTH, margin: '0 auto' }}>
              <SectionHeading
                eyebrow={i18n.helpTopicsEyebrow}
                title={i18n.helpProducts}
                mb={4}
                align="left"
                eyebrowSize={14}
                titleSize={40}
              />
              <Grid container spacing={5} alignItems="flex-start">
                <Grid item lg={4} xs={12}>
                  <HelpCategories
                    selectedCategory={selectedCategory}
                    onSelectCategory={handleSelectCategory}
                    showHeading={false}
                  />
                </Grid>
                <Grid item lg={8} xs={12}>
                  <HelpFaqs selectedCategory={selectedCategory} />
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}

        <HelpChannels isMobile={matchesMobile} />
      </Box>
    </ThemeProvider>
  );
};

export default HelpPage;
